import { cn } from "../../lib/utils"

interface TableProps {
  children?: React.ReactNode
  className?: string
  colSpan?: number
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
}

export function Table({ children, className }: TableProps) {
  return (
    <div className="w-full overflow-x-auto">
      <table className={cn("w-full text-sm", className)}>{children}</table>
    </div>
  )
}

export function TableHead({ children, className }: TableProps) {
  return <thead className={cn("bg-ink-50 dark:bg-ink-800/50", className)}>{children}</thead>
}

export function TableBody({ children, className }: TableProps) {
  return <tbody className={cn("", className)}>{children}</tbody>
}

export function TableRow({ children, className, onClick }: TableProps) {
  return (
    <tr onClick={onClick} className={cn("border-b border-ink-200 dark:border-ink-800 hover:bg-ink-50 dark:hover:bg-ink-800/30", className)}>
      {children}
    </tr>
  )
}

export function TableHeader({ children, className, colSpan }: TableProps) {
  return (
    <th colSpan={colSpan} className={cn("px-4 py-3 text-left font-semibold text-ink-700 dark:text-ink-300 text-xs uppercase tracking-wider", className)}>
      {children}
    </th>
  )
}

export function TableCell({ children, className, colSpan, onClick }: TableProps) {
  return <td colSpan={colSpan} onClick={onClick} className={cn("px-4 py-3 text-ink-800 dark:text-ink-200", className)}>{children}</td>
}
